<template>
    <section class="cgi-grid">
        <transition-group name="fade" tag="div" class="grid-cpt">
            <div 
                class="grid-cpt__item"
                v-bind:style="{ 'background-image': 'url(' + post.acf.background_image_archive.sizes.large + ')' }"
                :key="post.ID"
                @mouseover="videoPlay('video'+post.ID)"
                @mouseleave="videoPause('video'+post.ID)"
                v-on:click="showPopup('video'+post.ID)"
                v-for="(post, index) in filteredCGI"
                :class="widthClass(index)"
            >
            <!-- ( post.acf.popup_settings.time_poster !== 'custom' ) ? post.acf.popup_settings.time_poster : post.acf.popup_settings.custom_time -->
                <video :id="'video'+post.ID" :data-imagepopup="(post.acf.popup_image) ? post.acf.popup_image.url : ''" :data-popuptime="(post.acf.popup_settings) ? ( post.acf.popup_settings.time_poster !== 'custom' ) ? post.acf.popup_settings.time_poster : post.acf.popup_settings.custom_time : ''" class="grid-cpt__item__video" preload="none" loop muted playsinline :src="post.acf.hover_video_archive"></video>
                <div class="grid-cpt__item__title">click to view full render</div>
            </div>
        </transition-group>
        <div class="grid-cpt__loadmore">
            <div class="grid-cpt__loadmore__btn" @click="postsNumer += postsPerPage" v-if="postsNumer < filteredCGI.length">Load more</div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'CGI',
    data() {
        return {
            postsPerPage: 7,
            postsNumer: 7,
            posts: []
        }
    },
    create: function() {
    },
    methods: {
        videoPlay(item) {
            document.getElementById(item).play();
        },
        videoPause(item) {
            const vid = document.getElementById(item);
            vid.onplay = function() {
                vid.pause();
            };
        },
        widthClass(index) {
            let count = this.postsNumer,
                widthLast = index+1 % 10,
                widthClass = 'grid-cpt__item--';

            if( count % 10 && index == count ) {
                if ( widthLast == 1 || widthLast == 4 || widthLast == 6 || widthLast == 9 ) {
                    widthClass += 'full';
                } else if ( widthLast == 2 ) {
                    widthClass += 'height';
                } else if ( widthLast == 7 ) {
                    widthClass += 'before-height';
                } else {
                    widthClass = '';
                }
            } else {
                widthClass = '';
            }

            return widthClass;
        },
        showPopup(item) {
            const   video = document.getElementById(item),
                    videosrc = video.getAttribute('src'),
                    posterImage = video.getAttribute('data-imagepopup'),
                    posterTime = video.getAttribute('data-popuptime'),
                    popup = document.querySelector('.popup-video'),
                    popupImage = popup.querySelector('.popup-video__image'),
                    popupVideo = popup.querySelector('.popup-video__video');

            
            

            if( posterImage != '' ) {
                popup.classList.add('is-open');
                popup.classList.add('is-load');
                popup.classList.add('has-image');

                popupImage.setAttribute('src', posterImage);

            } else {
                popup.classList.add('is-open');
                popupVideo.setAttribute('src', videosrc);
                popupVideo.onloadeddata = function() {
                    if( posterTime == '' || posterTime == 'start' ) {
                        popupVideo.currentTime = 0;
                    } else if ( posterTime == 'end' ) {
                        popupVideo.currentTime = popupVideo.duration;
                    } else {
                        popupVideo.currentTime = posterTime;
                    }
                    setTimeout(() => {
                        popup.classList.add('is-load');
                    }, 500);
                };
            }
            
        }
    },
    computed: {
        filteredCGI() {
            return this.posts.filter((cgi, index) => {
                return index <= this.postsNumer; 
            })
        }
    },
    mounted() {
        this.axios.get('/wp-json/cgi/v1/post')
            .then(response => {
                this.posts = response.data;
            });
    }
}
</script>

<style lang="scss" scoped>
.grid-cpt {
    position: relative;
    overflow: hidden;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>